module.exports = __webpack_public_path__ + "static/media/employeeDirectorS.cff0477d.png";